import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appClickableContainer,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    ...theme.mixins.appContainersSpacing,
    cursor: 'default',
    '&:hover': {
      borderColor: 'transparent',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flex: 1,
    minWidth: 0,
  },
  avatarSkeleton: {
    flexShrink: 0,
  },
  titleSkeleton: {
    width: '100%',
    maxWidth: '60%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '100%',
    },
  },
  iconsBlock: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    flexShrink: 0,
  },
  iconSkeleton: {
    flexShrink: 0,
  },
}));
